import { call, select, takeEvery } from 'redux-saga/effects';

import config from 'config/config';
import { selectRouteParams } from 'containers/GlobalWrapper/selectors';
import { GET_PLAN, UPDATE_PLAN } from 'containers/OneProjectPage/PlansPage/constants';
import Analytics from 'utils/Analytics';
import checkOrSetSlash from 'utils/checkOrSetSlash';
import { uploadMedia } from 'utils/chunkUploader';
import { locationType } from 'utils/constants';
import request from 'utils/request';

// Resolves the analytics `file_format` from the resource's mime type and forwards the upload payload to the success callback.
function* processPostPlansResponse(organizationId, projectId, isBim, item, callbackSuccess, data) {
  const planType = isBim ? locationType.bim : locationType.plan;
  let type = 'image';
  const isPdf = item?.resources?.type?.includes('/pdf');
  const isDwg = item?.resources?.type?.includes('dwg') || item?.resources?.type?.includes('acad');
  const isIfc = item?.resources?.type?.includes('ifc');
  if (isPdf) {
    type = 'pdf';
  } else if (isDwg && !isBim) {
    type = 'dwg';
  } else if ((isDwg && isBim) || isIfc) {
    type = 'ifc';
  }
  Analytics.track('plans_plan_creation_succeeded', {
    file_format: type,
  });
  yield call(callbackSuccess, {
    ...item,
    ...data,
    loading: item.loading,
    version: data?.revision,
    type: planType,
  });
}

// Uploads the new plan media in chunks then PUTs the updated plan revision to the gateway.
export function* updatePlans({ item, callbackSuccess, callbackError }) {
  const route = yield select(selectRouteParams());
  const requestUploadMediaUrl = `${checkOrSetSlash(
    config.apiHostGateway,
    'apiHostGateway',
  )}api/v1.2/projects/${route.idData}/`;

  let payload;
  let data;

  const dataUpload = yield call(uploadMedia, item.resources, {
    baseUrl: requestUploadMediaUrl,
    parallel: false,
    requestHeaders: {
      'Content-Type': 'application/json',
    },
  });

  if (dataUpload && (dataUpload.message || dataUpload.status === 500)) {
    yield call(callbackError, item);
  } else {
    const requestURL = `${checkOrSetSlash(
      config.apiHostGateway,
      'apiHostGateway',
    )}api/v1.3/projects/${route.idData}/plans/${route.planId}`;

    payload = {
      ...item,
      folder_id: route.itemId && route.itemId !== 'root' ? route.itemId : null,
      media_resource: {
        root_media_resource_id: dataUpload.id,
        media_resource_id: dataUpload.id,
        media_resource_label: dataUpload.file_name,
      },
      thumbnail: null,
    };

    const options = {
      method: 'PUT',
      headers: {
        'Cache-Control': 'No-Store',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };

    data = yield call(request, requestURL, options);
  }

  if (data && (data.message || data.status === 500)) {
    yield call(callbackError, item);
  } else {
    yield* processPostPlansResponse(
      route.organizationId,
      route.idData,
      false,
      item,
      callbackSuccess,
      data,
    );
  }
}

export function* getPlan({ id, callbackSuccess, callbackError }) {
  const route = yield select(selectRouteParams());
  const requestURL = `${checkOrSetSlash(config.apiHostGateway, 'apiHostGateway')}api/projects/${
    route.idData
  }/plans/${id}`;

  const options = {
    method: 'GET',
    headers: {
      'Cache-Control': 'No-Store',
      'Content-Type': 'application/json',
    },
  };
  const data = yield call(request, requestURL, options, {
    errorRedirect: false,
  });
  if (data && !data.message) {
    if (callbackSuccess) {
      yield call(callbackSuccess, data);
    }
  } else if (callbackError) {
    yield call(callbackError, data);
  }
}

export default function* plansPageSaga() {
  yield takeEvery(UPDATE_PLAN, updatePlans);
  yield takeEvery(GET_PLAN, getPlan);
}
